import { supabase } from "../../Services/supabaseClient";
import { getCrmSettings } from "./crmSettingsService";

export const autoCreateOverdueCollectionCases = async (
  companyId,
  assignedTo
) => {
  const settings = await getCrmSettings(companyId);

  if (!settings.auto_create_collection_cases) {
    return [];
  }

  const today = new Date().toISOString().slice(0, 10);

  const { data: invoices, error: invoicesError } = await supabase
    .from("invoices")
    .select("id, company_id, account_id, expiryDate, total, amount_paid")
    .eq("company_id", companyId)
    .lt("expiryDate", today);

  if (invoicesError) {
    throw invoicesError;
  }

  const overdueInvoices = (invoices || []).filter((row) => {
    const totalAmount = Number(row.total_amount || 0);
    const amountPaid = Number(row.amount_paid || 0);
    return row.account_id && totalAmount - amountPaid > 0;
  });

  const createdCases = [];

  for (const invoice of overdueInvoices) {
    const { data: existing, error: existingError } = await supabase
      .from("crm_collections")
      .select("id")
      .eq("company_id", companyId)
      .eq("invoice_id", invoice.id)
      .limit(1);

    if (existingError) {
      throw existingError;
    }

    if ((existing || []).length > 0) {
      continue;
    }

    const nextFollowUpDate = new Date();
    nextFollowUpDate.setDate(
      nextFollowUpDate.getDate() +
        Number(settings.collections_followup_days || 3)
    );

    const { data: inserted, error: insertError } = await supabase
      .from("crm_collections")
      .insert([
        {
          company_id: companyId,
          account_id: invoice.account_id,
          invoice_id: invoice.id,
          assigned_to: assignedTo || null,
          status: "open",
          priority: "high",
          auto_created: true,
          note: "Auto-created from overdue invoice.",
          next_follow_up_at: nextFollowUpDate.toISOString(),
        },
      ])
      .select()
      .single();

    if (insertError) {
      throw insertError;
    }

    createdCases.push(inserted);
  }

  return createdCases;
};

export const markCollectionResolved = async (companyId, collectionId) => {
  const { data, error } = await supabase
    .from("crm_collections")
    .update({
      status: "resolved",
      resolved_at: new Date().toISOString(),
      last_contact_at: new Date().toISOString(),
    })
    .eq("company_id", companyId)
    .eq("id", collectionId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};
